<template>
    <div class="order-product-form ">
        <div class="order-product-form-image">
            <div class="overlay">
                <navbar />
                <h2 class="main-title">{{ $t('order_product_form.main_title') }}</h2>
            </div>
        </div>
        <product-form v-scrollanimation />
        <custom-footer />
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import ProductForm from "@/components/ProductForm.vue";
import CustomFooter from "@/components/CustomFooter.vue";
export default {
    name: "orderProductForm",
    components: {
        Navbar,
        ProductForm,
        CustomFooter
    },
    data() {
        return {};
    },
    mounted() {
        document.documentElement.scrollTop = 0;
    }
};
</script>

<style>
.order-product-form {
    position: absolute;
    z-index: 100;
}
.order-product-form .order-product-form-image {
    background-image: url(../assets/img/order.webp);
    position: relative;
    height: 80vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.order-product-form .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #126801b6, #15203bce);
}

.order-product-form .main-title{
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;
    padding-top: 130px;
}

@media (min-width: 992px) {
    .order-product-form .main-title {
        font-size: 50px;
    }
}

@media (max-width: 991px) {
    .order-product-form .main-title {
        font-size: 30px;
    }
}

.order-product-form .before-enter {
    opacity: 0;
    transform: translateY(150px);
    transition: all 2s;
}

.order-product-form .enter {
    opacity: 1;
    transform: translateY(0px);
}

</style>
